import { useNavigate } from 'react-router-dom';
import ProgressBar from '../Components/ProgressBar';
import Navbar from '../Components/Navbar';
import { Box, Text, Flex } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';

const EndSurvey = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/resources'); // Navigate to the next step 
  };

  return (
    <Box>
      {/* Top Bar */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Survey Content */}
      <Box padding="20px" maxWidth="1200px" margin="auto">
        <Text fontSize="20px" fontWeight="bold" mt="20px">Freelance Preference Survey</Text>
        <Text color="#6E6E6E" mb="12px" fontStyle="italic">
          Please fill this survey out so that we have a better understanding of how to assist you! :)
        </Text>

        {/* Progress Bar */}
        <Box padding="20px" maxWidth="1150px" margin="auto">
          <ProgressBar step={4} totalSteps={4} />
        </Box>

        <Text color="#000000" fontSize="16px" fontWeight="bold" textAlign={'center'} marginTop={'100px'}>
          Thank you! Your responses have been recorded
        </Text>
        {/* Navbar at Bottom */}
        <Box marginTop="50px">
          <Navbar />
        </Box>
      </Box>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom="100px"
        left="0"
        right="0"
        width="100%"
        justify="flex-end"
        padding="0 50px"
      >
        {/* Next Button */}
        <Flex align="center" cursor="pointer" onClick={handleNext}>
          <Text style={{ font: 'Inter', fontSize: '16px' }}>Go to Resource Home</Text>
          <ChevronRightIcon w={12} h={12} color="#10b981" />
        </Flex>
      </Flex>
    </Box>
  );
};

export default EndSurvey;
